export default __webpack_public_path__ + "static/media/pc5.1f8ee810.jpg";